module.exports = __webpack_public_path__ + "static/media/selfie.5f848405.png";